import * as yup from 'yup';

export const CreditTypeSchema = yup.object().shape({
  id: yup
    .number()
    .required("Please select credit type's ID")
    .typeError("Credit type's ID must be a number"),
  description: yup
    .string()
    .required('Please add a description')
    .typeError('Please add a description'),
  abbreviation: yup
    .string()
    .required('Please add an abbreviation')
    .typeError('Please add an abbreviation'),
  value: yup
    .number()
    .required('Please add a value')
    .typeError('Value must be a number'),
  is_studio_only: yup
    .boolean()
    .required('Please select if this is studio only')
    .typeError('Please select if this is studio only')
});
